import { OrganisationModel } from '@steelbuy/ts-shared';

import { OrganisationEntityData } from './OrganisationEntityData';
import { useEntityData } from '../../util/consumer/EntityConsumerHook';

export const useOrganisationEntityData = () => useEntityData<OrganisationModel>(OrganisationEntityData);
